export const HURTBOX_PROFILES = {
  default: {
    height: 90,
  },
  player: {
    height: 90,
  },
  enemy_melee: {
    height: 92,
  },
  enemy_light: {
    height: 86,
  },
  projectile: {
    top: 0,
    bottom: 0,
  },
};

export const COMBAT_TUNING = {
  enemyAttackCooldown: {
    melee: { base: 1000, jitter: 300 },
    ranged: { base: 1300, jitter: 350 },
  },
  knockbackDecayX: 0.88,
  projectile: {
    padding: 10,
  },
  throwSpawn: {
    forwardFactor: 1,
  },
  throwArc: {
    enabled: true,
    apexHeightPx: 50,
  },
};

export const ITEM_PICKUP_TUNING = {
  respawnDelayMs: 5000,
  healByTextureKey: {
    collectible_heart: 50,
    collectible_meat: 20,
    collectible_apple: 10,
  },
  bobAmplitudePx: 5,
  bobSpeedHz: 0.45,
  itemBobAmplitudePx: 2,
  itemLagRadians: 0.9,
  pickupPadding: 6,
  itemSizePx: 32,
  bubbleSizePx: 64,
  bubbleAlpha: 0.9,
  bubbleDepthOffset: 1,
  popDurationMs: 140,
  popScale: 1.18,
  popRisePx: 10,
};
